import React, {FunctionComponent, useCallback, useMemo} from "react";
import {ArticleLong} from "../articleLong";
import {Divider} from "../../divider";
import {ArticleLongData} from "@klear/open-site/interfaces";
import {BlogTitleLink} from "../blogTitleLink";


const styles = require('./articlesList.component.scss');

interface ArticlesListProps {
    mainTitle?: string,
    sideTitle?: string,
    posts: Array<ArticleLongData>
}

export const ArticlesList: FunctionComponent<ArticlesListProps> = props => {
    const {mainTitle, sideTitle, posts} = props;

    return (
        <>
            <div className={styles.container}>
                {mainTitle &&
                    <BlogTitleLink mainTitle={mainTitle} sideTitle={sideTitle} sideTitleLink={"all"} divider={true}/>}
                <div className={styles.containerBottom}>
                    {posts.map((articleData, i: number) => (
                        <>
                            <a key={i} href={articleData.slug}>
                                <ArticleLong mainArticleImage={articleData.imageUrl}
                                             mainArticleTitle={articleData.title}
                                             mainArticleDescription={articleData.description || ''}
                                />
                            </a>
                            {posts.length - 1 !== i &&
                                <Divider direction={"horizontal"}/>
                            }
                        </>
                    ))}
                </div>
            </div>
        </>
    )
}
